'use strict';

var productSpecs = '';

$(document).ready(function () {
    $('body').on('click', '.js-success-btn, .js-error-btn, .js-pdl-close', function (e) {
        var componentID = e.target.closest('.modal-notify-me').dataset.id;
        var modal = $('#modal-notify-me-' + componentID);
        modal.find('.default-msg').removeClass('d-none');
        modal.find('.success-msg, .error-msg').addClass('d-none');
        modal.find('.js-email')[0].value = '';
    });

    $('body').on('change', '.js-privacy', function (e) {
        if (e.target.checked)
            $(e.target).siblings('.invalid-feedback')[0].style.display = 'none';
        else
            $(e.target).siblings('.invalid-feedback')[0].style.display = 'block';
    });

    $('body').on('click', '.js-pdl-notify-me', function (e) {
        let card = e.target.closest('.js-card-product');
        productSpecs = JSON.parse(card.dataset.specs);

        let pdPdl = e.target.closest('.js-pd-pdl');

        let componentID = pdPdl
            ? pdPdl.dataset.id
            : e.target.closest('.js-departure-list').dataset.id;

        let modal = $('#modal-notify-me-' + componentID);

        if (!modal.parent().is('body')) {
            modal.appendTo('body');
        }

        modal.modal('show');
    });

    /*
    $('.js-preventivoPDL').each(function (index, el){
        var componentID = el.closest('.pd-productDepartureList').dataset.id;
        el.dataset.target = '#preventivoPDL-' + componentID;
    });

    $(document).on('click', '.js-preventivoPDL', function (e){
        var link = e.target.dataset.preventivourl;
        var componentID = e.target.closest('.pd-productDepartureList').dataset.id;
        var modal = $('#preventivoPDL-' + componentID)[0];
        $(modal).find('.js-confirm')[0].href = link;
    });
    */ //USE PREVENTIVO MODAL
});

